import UserPermissionsManager from "core/lib/user-permissions.manager";
import { UserDetails } from "core/services/cef/permission.service.types";
import { Permission } from "core/services/cef/types";

class UserDetailsWrapper {
    user: UserDetails;
    fullName: string;
    firstName: string;
    lastName: string;
    role: string;
    customerNumber: number;
    mobileNumber: string;
    email: string;
    financialAuth: boolean;
    ciam: string;
    permissions: Permission[];
    agreementIds?: number[];

    constructor(ud: UserDetails) {
        this.user = ud;
        const agreement = ud.agreements[0];

        this.fullName = `${ud.firstName} ${ud.lastName}`;
        this.firstName = ud.firstName;
        this.lastName = ud.lastName;
        this.customerNumber = ud.customerNumber;
        this.role = ud.role;
        this.mobileNumber = ud.phone;
        this.email = ud.email;
        this.financialAuth = UserPermissionsManager.userHasFinancialAccess(ud);
        this.ciam = ud.ciam;
        this.permissions = agreement.permissions;
        this.agreementIds = ud?.agreements.map((a: { id: number; }) => a.id);
    }

    get dataForTracking() {
        return {
            name: this.fullName,
            email: this.email
        }
    }
}

export default UserDetailsWrapper;
